// Namespace
import * as ProposalNS from './Proposal';
import { ProposalDAOInterface, DisclaimerConfig } from './DAOs/ProposalDAO';

export enum ProposalElementType {
  Data = 'DATA_ELEMENT',
  Layout = 'LAYOUT_ELEMENT',
  Section = 'SECTION_ELEMENT',
  Division = 'DIVISION_ELEMENT',
}

export type ProposalElement = ProposalDivisionElement | ProposalSectionElement | ProposalLayoutElement | ProposalDataElement;

export type ProposalDataElement = ProposalNS.ProposalTemplateDataElement & {
  elementType: ProposalElementType.Data;
  pageOverflowIndex: number;
  daoObject?: ProposalDAOInterface;
  parent?: ProposalLayoutElement | ProposalSectionElement;
};

export type ProposalLayoutElement = ProposalNS.ProposalTemplateLayoutElement & {
  elementType: ProposalElementType.Layout;
  parent?: ProposalLayoutElement | ProposalSectionElement;
  key?: string;
};

export type ProposalSectionElement = ProposalNS.ProposalTemplateSectionElement & {
  elementType: ProposalElementType.Section;
  parent?: ProposalLayoutElement | ProposalSectionElement;
  disclaimerConfigs?: DisclaimerConfig[];
  pageOverflowIndex: number;
  sectionKey: string;
  sectionIteratorIndex?: number; // when a section is repeated, this index gets set.
};

export type ProposalDivisionElement = ProposalNS.ProposalTemplateDivisionElement & {
  elementType: ProposalElementType.Division;
  parent?: ProposalDivisionElement;
};
